import { createFileRoute, Outlet, useMatches } from '@tanstack/react-router'
import { LandingNav } from '@/routes/-landing/nav'
import { Footer } from '@/routes/-landing/footer'
import { LandingShellPending } from '@/routes/_app/-components/shell-pending'

// Per-page chrome config, declared on each child route's `staticData` and read here. `hideFooter`: docs is the lone
// full-bleed page with no footer.
type LandingStaticData = {
  hideFooter?: boolean
}

export const Route = createFileRoute('/_landing')({
  component: LandingLayout,
  // Its component is its own chunk, like every shell's; while an entry awaits it, the page's skeleton paints.
  pendingComponent: LandingShellPending,
})

/**
 * The docs and the policy pages, under the landing's own top bar and footer. They carry no sections of their own, so
 * the bar comes up without them (see `LandingNav`).
 */
function LandingLayout() {
  const matches = useMatches()
  // staticData is typed as the generic StaticDataRouteOption; assert our per-page shape.
  // oxlint-disable-next-line typescript/no-unnecessary-type-assertion
  const config = matches.at(-1)?.staticData as LandingStaticData | undefined

  return (
    <>
      <LandingNav />
      <Outlet />
      {!config?.hideFooter && <Footer />}
    </>
  )
}
